
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Usar requestAnimationFrame para garantir que o scroll aconteça após o DOM estar pronto
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [location.pathname]);

  return null;
};

export default RouteScrollToTop;
